/** «Отгрузка 28.10 · сегодня» из YYYY-MM-DD; дату показываем как есть, без часовых поясов. */
export function shipmentDayLabel(day) {
  const m = String(day || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "Без даты отгрузки";
  const now = new Date();
  const p = (n) => String(n).padStart(2, "0");
  const iso = (d) =>
    `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  const tomorrow = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1,
  );
  const key = `${m[1]}-${m[2]}-${m[3]}`;
  let hint = "";
  if (key < iso(now)) hint = " · просрочено";
  else if (key === iso(now)) hint = " · сегодня";
  else if (key === iso(tomorrow)) hint = " · завтра";
  return `Отгрузка ${m[3]}.${m[2]}${hint}`;
}
